import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-suggestion-drug-sample-card',
  templateUrl: './suggestion-drug-sample-card.component.html',
  styleUrls: ['./suggestion-drug-sample-card.component.scss']
})
export class SuggestionDrugSampleCardComponent {

  @Input () drugListObj;

  constructor(private router:Router) { }

  navigateToDetail(drug_id): void {
    this.router.navigateByUrl('drugsample/detail/' + drug_id);
  }

}
